import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

const SyncPage: React.FC = () => {
  const { t } = useTranslation();
  const { token, user } = useAuth();
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [backup, setBackup] = useState('');

  const handleDownload = async () => {
    setError(null); setMessage(null);
    try {
      const res = await fetch('/api/sync/download', {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || t('download_failed'));
      setBackup(JSON.stringify(data.backup, null, 2));
      setMessage(t('backup_downloaded'));
    } catch (err: any) {
      setError(err.message);
    }
  };

  const handleUpload = async () => {
    setError(null); setMessage(null);
    try {
      const res = await fetch('/api/sync/upload', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ backup: JSON.parse(backup) }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || t('upload_failed'));
      setMessage(t('backup_uploaded'));
    } catch (err: any) {
      setError(err.message);
    }
  };

  if (!user || user.role !== 'premium') {
    return <div style={{ padding: 32 }}>{t('premium_required')}</div>;
  }

  return (
    <div style={{ maxWidth: 600, margin: 'auto', padding: 32 }}>
      <h2>{t('sync')} ({t('premium')})</h2>
      <button onClick={handleDownload}>{t('download_backup')}</button>
      <button onClick={handleUpload} style={{ marginLeft: 8 }}>{t('upload_backup')}</button>
      <div>
        <label htmlFor="backup_textarea">{t('backup_placeholder')}</label>
        <textarea
          id="backup_textarea"
          rows={10}
          style={{ width: '100%', marginTop: 16 }}
          value={backup}
          onChange={e => setBackup(e.target.value)}
          placeholder={t('backup_placeholder')}
        />
      </div>
      {message && <div style={{ color: 'green' }} role="alert">{message}</div>}
      {error && <div style={{ color: 'red' }} role="alert">{error}</div>}
    </div>
  );
};

export default SyncPage; 